import React from 'react';
import { Link } from 'react-router-dom';


const ErrorOne = () => {
    return(
        <>
        {/*404 Section*/}
        <section className="error-404-section section-padding-default">
            <div className="default-container">
            <div className="row clearfix">
                <div className="col-lg-12">
                <div className="error-404">
                    <h1>404!</h1>
                    <h5>Page Not Found!</h5>
                    <p>We are sorry, The page you were looking for doesn't exsit.</p>
                    <Link to="./" className="btn btn_custom corpo-r-btn btn-style-two">GO HOME</Link>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End 404 Section*/}
        </>
    )
}

export default ErrorOne;